const OAUTH_LOGOS_BASE_URL = `${import.meta.env.BASE_URL.replace(/\/$/, '')}/oauth-logos`

export interface McpLogo {
  src: string
  alt: string
}

export const MCP_LOGOS: McpLogo[] = [
  { src: `${OAUTH_LOGOS_BASE_URL}/claude.svg`, alt: 'Claude' },
  { src: `${OAUTH_LOGOS_BASE_URL}/chat-gpt.svg`, alt: 'ChatGPT' },
  { src: `${OAUTH_LOGOS_BASE_URL}/microsoft-copilot.svg`, alt: 'Microsoft Copilot' },
]

export const MCP_LOGOS_MONO: McpLogo[] = [
  { src: `${OAUTH_LOGOS_BASE_URL}/claude-mono.svg`, alt: 'Claude' },
  { src: `${OAUTH_LOGOS_BASE_URL}/chat-gpt-mono.svg`, alt: 'ChatGPT' },
  { src: `${OAUTH_LOGOS_BASE_URL}/microsoft-copilot-mono.svg`, alt: 'Microsoft Copilot' },
]
